/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Find_Card_DetailInputs */

const en_portal_step_find_card_detail = /** @type {(inputs: Portal_Step_Find_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal trainer · from 150 zł`)
};

const pl_portal_step_find_card_detail = /** @type {(inputs: Portal_Step_Find_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerka personalna · od 150 zł`)
};

/**
* | output |
* | --- |
* | "Personal trainer · from 150 zł" |
*
* @param {Portal_Step_Find_Card_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_find_card_detail = /** @type {((inputs?: Portal_Step_Find_Card_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Find_Card_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_find_card_detail(inputs)
	return en_portal_step_find_card_detail(inputs)
});